<onboarding-events--preview :event="previewEvent" :include-day="includeDay" :draggable="false" :transparent="transparent"></onboarding-events--preview>